import React from 'react'

import './PostListItem.css'

class PostListItem extends React.Component {
    render() {
        const { label, deleteItem, onToggleImoprtant, onToggleLiked, important, liked } = this.props

        let importantClass = 'fa-solid fa-check',
            likedClassNames = '',
            likedClass = 'fa fa-heart'

        if (important) {
            importantClass += " important"
        }

        if (liked) {
            likedClassNames += ' liked';
            likedClass += ' likeds'
        }

        return (
            <li className="app-list-item d-flex justify-content-between">
                <span className="app-list-item-label" onClick={ onToggleLiked }>
                    { label }
                </span>
                <div className="d-flex justify-content-center align-items-center">
                    <button className="important" onClick={
                        onToggleImoprtant }>
                        <i class={ importantClass }></i>
                    </button>
                    <button className="btn-trash btn-sm" onClick={ deleteItem }>
                        <i className="fa fa-trash" aria-hidden="true"></i>
                    </button>
                    <button className={ likedClassNames } onClick={ onToggleLiked }>
                        <i className={ likedClass }></i>
                    </button>
                </div>
            </li>
        )
    }
}

export default PostListItem






